import { NodeViewWrapper } from "@tiptap/react";
import { useBlogMediaSrc } from "./blogShared.jsx";
import { isBlogS3Key } from "./blogMedia.js";

const BlogImageView = ({ node }) => {
    const local = node.attrs.pendingId && node.attrs.src && !isBlogS3Key(node.attrs.src)
        ? node.attrs.src
        : "";
    const key = node.attrs.s3Key || (isBlogS3Key(node.attrs.src) ? node.attrs.src : "");
    const remote = useBlogMediaSrc(local ? "" : key, "image");
    const src = local || remote || (!key ? node.attrs.src : "");
    return (
        <NodeViewWrapper className="blog__inline-image-wrap">
            {src ? (
                <img src={src} alt={node.attrs.alt || ""} className="blog__inline-image" />
            ) : (
                <span className="blog__inline-image-wait">Loading image…</span>
            )}
        </NodeViewWrapper>
    );
};

export default BlogImageView;
